var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_4796)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33335 9.33325C10.8061 9.33325 12 10.5272 12 11.9999V19.9999C12 22.2091 10.2092 23.9999 8.00002 23.9999H6.66669C8.13945 23.9999 9.33335 22.806 9.33335 21.3333V9.33325ZM20 9.33325H22.6667C24.1394 9.33325 25.3334 10.5272 25.3334 11.9999V18.6666C25.3334 21.6121 22.9455 23.9999 20 23.9999H17.3334C20.2789 23.9999 22.6667 21.6121 22.6667 18.6666V11.9999C22.6667 10.5272 21.4728 9.33325 20 9.33325Z",
    fill: "url(#paint0_linear_887_4796)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9999C0 10.5272 1.19391 9.33325 2.66667 9.33325H9.33333V21.3333C9.33333 22.806 8.13943 23.9999 6.66667 23.9999H5.33333C2.38781 23.9999 0 21.6121 0 18.6666V11.9999Z",
    fill: "url(#paint1_linear_887_4796)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 11.9999C22.6667 10.5272 21.4728 9.33325 20 9.33325H13.3334V21.3333C13.3334 22.806 14.5273 23.9999 16 23.9999H17.3334C20.2789 23.9999 22.6667 21.6121 22.6667 18.6666V11.9999Z",
    fill: "url(#paint2_linear_887_4796)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 9.33325H9.33331V12.6666H13.3333V9.33325ZM29.3333 9.33325H20C21.4727 9.33325 22.6666 10.5272 22.6666 11.9999V12.6666H28.6666V18.6666C30.5076 18.6666 32 17.1742 32 15.3333V12.6666V11.9999C32 10.5272 30.8061 9.33325 29.3333 9.33325Z",
    fill: "#FAB215"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4796",
    x1: 9.33335,
    y1: 13.9999,
    x2: 9.33335,
    y2: 23.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4796",
    x1: 2.66667,
    y1: 23.9999,
    x2: 14.0083,
    y2: 15.7975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_887_4796",
    x1: 14,
    y1: 23.3333,
    x2: 13.5124,
    y2: 9.61118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_4796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.1c80a590e66849e65295bd9906cf1a9a.svg";
export { ForwardRef as ReactComponent };